import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class UsersService {
    constructor(http) {
        this.http = http;
        this.endpoints = {
            get: 'user',
            overview: 'user/list',
            create: 'user/create',
            update: 'user/update',
            count: 'user/count',
            generateToken: 'user/generateToken',
            manufacturingUser: 'ManufacturingUser',
            delete: 'user',
            help: 'help',
        };
    }
    /**
    * Retrieves an array of profiles using the provided filter.
    * @param {Filter} filter The filter.
    */
    filter(filter) {
        return this.http.post(this.endpoints.get, filter).pipe(map(profiles => profiles || []));
    }
    /**
    * Retrieves an array of profiles using the provided filter.
    * @param {Filter} filter The filter.
    */
    getOverview(filter) {
        return this.http.post(this.endpoints.overview, filter).pipe(map(profiles => profiles || []));
    }
    /**
     * Retrieves the total count of users using the provided filter.
     * @param {Filter} filter The filter.
     */
    count(filter) {
        return this.http.post(this.endpoints.count, filter).pipe(map(count => count || 0));
    }
    /**
     * Retrieves the user using the specified identifier.
     * @param {string} id The identifier.
     */
    getById(id) {
        return this.http.get(`${this.endpoints.get}/${id}`);
    }
    /**
     * Adds the provided user.
     * @param {User} user The user.
     */
    add(user) {
        return this.http.post(`${this.endpoints.create}`, user);
    }
    /**
     * Updates the provided User.
     * @param {User} profile The Profile.
     */
    update(user) {
        return this.http.post(this.endpoints.update, user);
    }
    /**
     * Deletes the provided user.
     * @param {string} id The identifier.
     */
    delete(id) {
        return this.http.delete(`${this.endpoints.delete}/${id}`);
    }
    generateToken(id) {
        return this.http.get(`${this.endpoints.generateToken}/${id}`, { responseType: "text" });
    }
    prepareManufacturingSecret(id) {
        return this.http.post(`${this.endpoints.manufacturingUser}/${id}/manufacturing-secret/prepare`, null);
    }
    activateManufacturingSecret(id, secret) {
        return this.http.post(`${this.endpoints.manufacturingUser}/${id}/manufacturing-secret/activate`, { secret });
    }
    /**
     * Get Help file
     */
    help() {
        return this.http.get(`${this.endpoints.get}/${this.endpoints.help}`, { responseType: "blob" });
    }
}
UsersService.ngInjectableDef = i0.defineInjectable({ factory: function UsersService_Factory() { return new UsersService(i0.inject(i1.HttpClient)); }, token: UsersService, providedIn: "root" });
